<template>
<div class="component" @click="$emit('selectAnnouncement',announcement)">

    <div class="card">
        <header class="card-header-enaq">
            <div class="card-header-title-enaq">
                {{announcement.title}}
            </div>

        </header>
        <div class="card-content">
            <div class="content ">
                {{announcement.description}}
            </div>
        </div>
        <footer class="card-footer" v-if="!adminview">
            <a href="#" class="card-footer-item" @click="openMoreInfo=true">{{$t('enaq_translation_dashboard_messages_more_info')}}</a>
        </footer>
    </div>

    <div class="modal is-active" v-if="openMoreInfo">
        <div class="modal-background" @click="openMoreInfo=false"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{announcement.title}}</p>
                <button class="delete" aria-label="close" @click="openMoreInfo=false"></button>
            </header>
            <section class="modal-card-body announcementContent">
                {{announcement.content}}
            </section>
            <footer class="modal-card-foot">
                <button class="button" @click="openMoreInfo=false">Cancel</button>
            </footer>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'component',
    props: ["announcement","adminview"],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            openMoreInfo: false,
        }
    },
    methods: {},
    computed: {},
}
</script>

<style scoped>
.component {
    margin: 15px 0
}

.announcementContent {
    color: black;
}
.card-header-enaq{
    box-shadow: 0 1px 2px rgba(10, 10, 10, 0.1);
    text-align:center;
}
.card-header-title-enaq {
    text-align: center;
    font-size: 1.2rem;
    font-weight: bolder;
    padding: 0.6rem 0;
}
</style>
